import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropdown from 'react-toolbox/lib/dropdown';
import Checkbox from 'react-toolbox/lib/checkbox';
import DatePicker from '~/components/DatePicker';

const defaults = {
  period: 'today',
  showDateFields: false
};

class UserBoxStatsSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      outdata: {
        ...defaults,
        ...props.indata
      }
    };
  }

  componentDidMount() {
    this.onChange();
  }

  onChange() {
    this.props.onChange(this.state.outdata);
  }

  setOutdataValue(property, value) {
    this.setState(
      { outdata: { ...this.state.outdata, [property]: value } },
      this.onChange
    );
  }

  setOutdataValues(obj) {
    this.setState(
      { outdata: { ...this.state.outdata, ...obj } },
      this.onChange
    );
  }

  render() {
    const periods = [
      { value: 'today', label: 'Today' },
      { value: 'yesterday', label: 'Yesterday' },
      { value: 'last_week', label: 'Last week' },
      { value: 'last_month', label: 'Last month' },
      { value: 'fixed_date', label: 'Fixed date' }
    ];
    return (
      <div>
        <Dropdown
          onChange={val =>
            this.setOutdataValues({ period: val, from: null, to: null })
          }
          source={periods}
          value={this.state.outdata.period}
          label="Period"
        />
        {this.state.outdata.period === 'fixed_date' && (
          <div>
            <div className="pullLeft" style={{ width: '50%' }}>
              <DatePicker
                label="From"
                locale="us"
                sundayFirstDayOfWeek
                onChange={from => {
                  this.setOutdataValue('from', from);
                }}
                value={this.state.outdata.from}
              />
            </div>
            <div className="pullRight" style={{ width: '50%' }}>
              <DatePicker
                label="To"
                locale="us"
                sundayFirstDayOfWeek
                onChange={to => {
                  this.setOutdataValue('to', to);
                }}
                value={this.state.outdata.to}
              />
            </div>
          </div>
        )}
        <div>
          <Checkbox
            checked={this.state.outdata.showDateFields}
            label="Show date fields"
            onChange={val => this.setOutdataValue('showDateFields', val)}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, null, null, { pure: false })(
  UserBoxStatsSettings
);



// WEBPACK FOOTER //
// ./app/widgets.new/UserBoxStats/settings.js